import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { applySsoAction, planIssueSsoTicket } from "@/auth/rpc/sso"

const searchSchema = z.object({
  returnTo: z.string().min(1),
})

/**
 * Issues a short-lived SSO ticket when the user already has a session here,
 * then redirects to the sister app's /sso/consume.
 */
export const Route = createFileRoute("/sso/issue")({
  validateSearch: (search) => searchSchema.parse(search),
  beforeLoad: async ({ search }) => {
    const action = await planIssueSsoTicket({
      data: { returnTo: search.returnTo },
    })
    applySsoAction(action)
  },
})
